import React from 'react';
import { Row, Col } from 'react-bootstrap';

import OrderDetailListViewContainer from '../containers/OrderDetailListViewContainer.jsx';

export default class OrderEditComponent extends React.Component {

	componentDidMount() {
	}

	render() {
		let noteDisply = this.props.order.get('noteDisplay');
		let note = '';
		if (this.props.showNote) {
			note = this.props.order.get('note');
		}

		return (
			<div>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<table className="table table-bordered">
							<tbody>
								<tr>
									<td colSpan="4" style={{ textAlign: 'center' }}><h4>客 戶 訂 單 審 查 表</h4></td>
								</tr>
								<tr>
									<td colSpan="2">編號:{this.props.order.get('orderId')}</td>
									<td colSpan="2">日期:{this.props.order.get('sOrderDate')}</td>
								</tr>
								<tr>
									<td>客戶名稱</td>
									<td>{this.props.order.get('customerName')} ({this.props.order.get('customerId')})</td>
									<td>訂貨人: {this.props.order.get('caseOfficer')}</td>
									<td>電話: {this.props.order.get('phone')}</td>
								</tr>
								<tr>
									<td>地址</td>
									<td>{this.props.order.get('address')}</td>
									<td>交期: {this.props.order.get('sDueDate')}</td>
									<td>傳真: {this.props.order.get('fax')}</td>
								</tr>
								<tr>
									<td>用途</td>
									<td colSpan="2">{this.props.order.get('caseName')}</td>
									<td>案號: {this.props.order.get('caseNumber')}</td>
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>
				<Row style={{ paddingTop: -20 }}>
					<Col xs={12} sm={12} md={12}>
						<OrderDetailListViewContainer orderId={this.props.order.get('orderId')} />
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<pre style={{ backgroundColor: 'white' }}>
							{noteDisply}
							<br />
							{note}
						</pre>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/OrderViewComponent.jsx